import ApiReadonly from "./api-readonly";

class RolService extends ApiReadonly {
  resource = "roles";
  primaryKey = "idrol";
}

export default new RolService();
